module.exports = __webpack_public_path__ + "static/media/DrogoMRunningShoeForMen.63a2d036.jpeg";